// extracted by mini-css-extract-plugin
export default {"operation_menu":"OperationMenu_operation_menu__fiY89","hot":"OperationMenu_hot__yu6CB","hotBox":"OperationMenu_hotBox__tfEvd"};